export default {
	state: {
		leave: [],
		leaveStatuses: [],
		leaveTypes: []
	},

	actions: {
		getLeave(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/GetLeave?userid=" + profile.userid + "&getTime=true")
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setLeave", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getLeaveStatuses(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"d_ddlo.value, " +
						"d_ddlo.name";

					var tableName = "" +
						"@db.def_ddloptions d_ddlo " +
						"inner join @db.def_fields d_f on d_ddlo.fieldid = d_f.id " +
						"inner join @db.def_tables d_t on d_f.tableid = d_t.id";

					var filter = "" +
						"d_t.name = 'leaveperiods' " +
						"and d_f.name = 'status'";

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/GetTableData?columns=" + columns + "&tableName=" + tableName + "&filter=" + filter)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setLeaveStatuses", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getLeaveTypes(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/GetLeaveTypes")
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setLeaveTypes", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		save(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/SaveLeaveRequest?id=" + parameters.id + "&userid=" + parameters.userid + "&name=" + parameters.name + "&from=" + parameters.from + "&to=" + parameters.to + "&leavetypeid=" + parameters.leavetypeid + "&savetime=" + parameters.savetime)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Save", content: "Time Off saved!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		cancel(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeactivateLeaveRequest?id=${parameters.id}&userid=${parameters.userid}&from=${parameters.from}&to=${parameters.to}&savetime=${parameters.savetime}`)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Delete", content: "Time Off cancelled!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		delete(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteLeaveRequest?id=${parameters.id}&userid=${parameters.userid}`)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Delete", content: "Time Off deleted!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setLeave(state, leave) {
			state.leave = leave
		},
		setLeaveStatuses(state, leaveStatuses) {
			state.leaveStatuses = leaveStatuses
		},
		setLeaveTypes(state, leaveTypes) {
			state.leaveTypes = leaveTypes
		}
	},

	namespaced: true
}